export const style = {
  LoadingContainer: {
    display: 'flex',
    height: 'calc(100vh - 64px)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  MainContainer: {
    display: 'flex',
    height: 'calc(100vh - 64px)',
    backgroundColor: 'white',
  },
  MainHeading: {
    backgroundColor: 'var(--tin-darkblue)',
    color: 'white',
  },
  ComponentMain: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  ActivePeriodText: {
    margin: '0px',
    fontSize: '11px',
    lineHeight: 'normal',
    fontWeight: 'bold',
  },
  HeaderText: {
    flex: 1,
    lineHeight: '20px',
    display: 'block',
  },
  TableContainer: {
    flex: 1,
    margin: '20px',
    boxShadow: '-1px 2px 15px -5px black',
    backgroundColor: 'white',
    borderRadius: '10px',
    minHeight: '45vh',
  },
  FlexCol: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: 'var(--tin-lightgrey)',
  },
  Headings: {
    flex: 1,
    display: 'flex',
    padding: '20px',
    flexDirection: 'row',
  },
  CardHeadingText: {
    flex: 3,
    display: 'flex',
    fontSize: '20px',
    fontWeight: 'bold',
    color: 'black',
  },
  ProjectsSelection: {
    flex: 1,
    display: 'flex',
    padding: '5px',
  },
  Select: {
    backgroundColor: 'white',
    padding: '10px',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'solid 2px var(--tin-darkblue)',
    color: 'var(--tin-grey)',
    ':focus': {
      outline: 'none',
    },
  },
  CentralizedRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  FilledButton: {
    backgroundColor: 'var(--tin-darkblue)',
    color: 'white',
    border: 'solid 1px white',
    borderRadius: '10px',
    height: '22px',
    width: 'auto',
    cursor: 'pointer',
    padding: '0px 20px',
    margin: '0px 10px',
  },
  BorderedButton: {
    backgroundColor: 'white',
    color: 'var(--tin-darkblue)',
    border: 'solid 1px var(--tin-darkblue)',
    borderRadius: '10px',
    height: '22px',
    width: 'auto',
    padding: '0px 20px',
    margin: '0px 10px',
    cursor: 'pointer',
  },
  PinkBorderedButton: {
    backgroundColor: 'white',
    color: 'var(--tin-cancel-pink)',
    border: 'solid 1px var(--tin-cancel-pink)',
    borderRadius: '10px',
    height: '22px',
    width: 'auto',
    margin: '0px 10px',
    padding: '0px 20px',
    cursor: 'pointer',
  },
  ListView: {
    flex: 2,
    overflowY: 'scroll',
    boxShadow: 'var(--tin-grey) 4px 1px 20px -5px',
  },
  ListViewContainer: {
    flex: 7,
  },
  SelectedClientItem: {
    backgroundColor: 'var(--tin-darkblue)',
  },
  UnselectedClientItem: {
    color: 'var(--tin-grey)',
  },
  SelectedClientText: {
    color: 'white',
  },
  UnselectedClientText: {
    color: 'var(--tin-grey)',
  },
  Container: {
    width: '100%',
    height: '100%',
  },
  Row: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '20px',
  },
  LabelValueCol: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '5px',
  },
  Label: {
    flex: 2,
    padding: '5px',
    fontSize: '16px',
    color: 'var(--tin-grey)',
  },
  Value: {
    flex: 3,
    fontSize: '14px',
    color: 'var(--tin-darkblue)',
    padding: '5px',
    margin: '0px',
    fontWeight: 'bold',
  },
  ButtonContainer: {
    padding: '20px',
  },
};
